<div>
    
  <div class="modal-header PerformanceTrendModalHead">
    <h5 class="modal-title">{{"categoriesReport"|translate}}</h5>
    <button type="button" class="close" (click)="closeActiveModal(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

    <div class="PerformanceTrendModalBody ">

    <div class="selectPeriodPan selectPeriodModal col-sm-12 col-xs-12 col-md-3 col-lg-3">
   <app-report-filter (outputData)="addItem($event)" [showCategoryDropDown]="true"></app-report-filter>  
  </div> 
  <div class="col-sm-12 col-xs-12 col-md-5 col-lg-9" style="display: block">
    <canvas baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [colors]="barChartColors"          
            [chartType]="barChartType"
            (chartHover)="chartHovered($event)"
            (chartClick)="chartClicked($event)"></canvas>

  </div>

  </div>

  <div class="modal-footer" style="font-weight: 800;">
    <button  type="button" class="btn btn-light" (click)="closeActiveModal(false)">{{'close' |
    translate
    }}</button>
</div>

</div>
